var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShieldCheckered = function SvgIconShieldCheckered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 3.5a1.75 1.75 0 0 0-1.75 1.75v5.503a14 14 0 0 0 .066 1.385c.73 7.487 7.284 10.036 8.622 10.482.364.13.76.13 1.124 0 1.338-.445 7.883-2.992 8.62-10.466q.009-.058.012-.118.056-.619.056-1.283V5.25A1.75 1.75 0 0 0 19.5 3.5zm.25 2v5.253q0 .124.002.247H11V5.5zm8.25 0V11h6.248l.002-.247V5.5zM11 13H4.966c.87 4.335 4.165 6.434 6.034 7.295zm2 7.295V13h6.034c-.87 4.335-4.165 6.434-6.034 7.295",
    clipRule: "evenodd"
  })));
};
export default SvgIconShieldCheckered;